module.exports = __webpack_public_path__ + "img/icon-cog.a37a9019.svg";